import React from 'react';

function AffiliateHeader(props){
    return (
        <div style={{textAlign:'center'}}>
            <h1 style={{color:'#fff',fontWeight:'500',fontSize:'2rem',paddingBottom:'1rem'}}>{props.name}</h1>
        </div>
    );
}
export default AffiliateHeader;


// WEBPACK FOOTER //
// ./src/AffiliateLandingPage/AffiliateHeader.jsx